import {Disposable, Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {DiscardReportDraftInput, DiscardReportDraftMutation} from './__generated__/DiscardReportDraftMutation.graphql';

const mutation = graphql`
	mutation DiscardReportDraftMutation($input: DiscardReportDraftInput!) {
		discardReportDraft(input: $input) {
			draftState
			publishedAt
			locked
			draftFilterWillRevert
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<DiscardReportDraftInput>,
	onSuccess?: RelayOnCompleted<DiscardReportDraftMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
